import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { connectState, getTrackByFn, InputObservable } from '@y42/angular/util';
import { importIcon } from '@y42/icons';
import { ImportWriteType } from '@y42/json-schema';
import { UnwrapArray } from '@y42/typescript';
import { map, Observable } from 'rxjs';

type ImportTypeList = Array<{ type: ImportWriteType; count: number }>;
type ImportTypeListable = ImportWriteType | ImportTypeList;

@UntilDestroy()
@Component({
  selector: 'y42-import-type',
  templateUrl: './import-type.component.html',
  styleUrls: ['./import-type.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ImportTypeComponent {
  @Input()
  @InputObservable()
  importType?: ImportTypeListable;
  importType$!: Observable<ImportTypeListable>;

  readonly ImportWriteType = ImportWriteType;
  readonly importIcon = importIcon;

  readonly trackByType = getTrackByFn<UnwrapArray<ImportTypeList>>('type');

  readonly state = connectState(this, {
    valueAsSingle: this.importType$.pipe(
      map((value): ImportWriteType | undefined => (!Array.isArray(value) ? value : undefined)),
    ),
    valueAsArray: this.importType$.pipe(
      map((value): ImportTypeList | undefined => (Array.isArray(value) ? value : undefined)),
    ),
  });
}
